const parseBlockedBranchIds = (): number[] => {
  const raw = process.env.REACT_APP_BLOCK_BRANCH_ID ?? '';
  if (!raw.trim()) return [];

  return raw
    .split(',')
    .map(id => Number(id.trim()))
    .filter(id => !Number.isNaN(id));
};

export const isBlockedBranch = (branchId: number | string | null | undefined): boolean => {
  const blockedIds = parseBlockedBranchIds();
  if (!blockedIds.length || branchId == null) return false;

  return blockedIds.includes(Number(branchId));
};
